// Pure helpers for turning the flat "questions" list (each with its own
// answerConnectorsFrom/answerConnectorsNext) into a connectors index and a
// renderable edges array for the canvas.

export function buildConnectorsIndex(questions) {
    const connectors = {};
    for (const question of questions) {
        for (const connector of question.answerConnectorsFrom) {
            connectors[connector.id] = connector;
        }
        for (const connector of question.answerConnectorsNext) {
            connectors[connector.id] = connector;
        }
    }
    return connectors;
}

// Question that holds this connector in its answerConnectorsNext list
// (i.e. the question this connector points to).
export function findQuestionByNextConnector(questions, connectorId) {
    return questions.find(question =>
        question.answerConnectorsNext.some(item => item.id == connectorId)
    );
}

// Question that holds this connector in its answerConnectorsFrom list
// (i.e. the question this connector originates from).
export function findQuestionByFromConnector(questions, connectorId) {
    return questions.find(question =>
        question.answerConnectorsFrom.some(item => item.id == connectorId)
    );
}

function connectorColor(connector) {
    if (connector.isRight && connector.isRight.id == 1) return "#30e846";
    if (connector.isRight && connector.isRight.id == 2) return "#f47126";
    return "#a2a2a2";
}

export function buildEdges(questions, connectors) {
    if (!connectors) return [];

    return Object.values(connectors)
        .map(connector => {
            const from = findQuestionByFromConnector(questions, connector.id)?.id;
            const to = findQuestionByNextConnector(questions, connector.id)?.id;

            if (!from || !to) return null;

            return {
                id: connector.id,
                from,
                to,
                color: connectorColor(connector),
            };
        })
        .filter(Boolean);
}
